import React from 'react';
import SideNav, { NavItem, NavIcon, NavText } from '@trendmicro/react-sidenav';

import { Translate } from '@styled-icons/heroicons-outline/Translate';
import { Wpforms } from '@styled-icons/fa-brands/Wpforms';
import { QuestionAnswer } from '@styled-icons/material/QuestionAnswer';
import { GraphUp } from '@styled-icons/bootstrap/GraphUp';
import { UserPin } from '@styled-icons/boxicons-regular/UserPin';
import { Dashboard as DashboardIcon } from '@styled-icons/boxicons-solid/Dashboard';
import { EventNote } from '@styled-icons/material-twotone/EventNote';
import { Shopify } from '@styled-icons/boxicons-logos/Shopify';
import { ShoppingCartOutline } from '@styled-icons/evaicons-outline/ShoppingCartOutline';
import { SwitchHorizontal } from '@styled-icons/heroicons-outline/SwitchHorizontal';
import { FileHtml } from '@styled-icons/boxicons-solid/FileHtml';
import { TextGrammarCheckmark } from '@styled-icons/fluentui-system-filled/TextGrammarCheckmark';
import { Users } from '@styled-icons/fa-solid/Users';
import { CloudUpload } from '@styled-icons/material-rounded/CloudUpload';

import { getUserGeren } from "../../../../utils/authusuariogerenciamento";

import '@trendmicro/react-sidenav/dist/react-sidenav.css';

const Menus = ({ handleMenu, user }) => {

    const MenuAutenticado = () => {
        const user = getUserGeren();
        return (
            <SideNav
                style={{ position: "fixed", background: "#e44745" }}
                onSelect={(selected) => {
                    handleMenu(selected);
                }}>
                <SideNav.Toggle />
                <SideNav.Nav defaultSelected="home">
                    
                    <NavItem eventKey="login">
                        <NavIcon>
                            <UserPin size="35" /><i className="fa fa-fw fa-line-vendas" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Login
                        </NavText>
                        <NavItem eventKey="login/cadastro">
                            <NavText>
                                Meus Dados
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="login/sair">
                            <NavText>
                                Sair
                            </NavText>
                        </NavItem>
                    </NavItem>
                    
                    <NavItem eventKey="selecionaevento">
                        <NavIcon>
                            <SwitchHorizontal style={{ cursor: "pointer" }} size="30" /><i className="fa fa-fw fa-dashboard" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Selecionar Evento
                        </NavText>
                    </NavItem>
                    <NavItem eventKey="dashboard">
                        <NavIcon>
                            <DashboardIcon size="30" /><i className="fa fa-fw fa-dashboard" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Dashboard
                        </NavText>
                    </NavItem>

                    <NavItem eventKey="dashboard">
                        <NavIcon>
                            <Users size="30" /><i className="fa fa-fw fa-dashboard" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Suporte
                        </NavText>
                        <NavItem eventKey="eventos/suporte/credenciamento">
                            <NavText>
                                Suporte Credenciamento
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="eventos/suporte/congressos">
                            <NavText>
                                Suporte Congresso
                            </NavText>
                        </NavItem>
                    </NavItem>
                    
                    <NavItem eventKey="eventos">
                        <NavIcon>
                            <EventNote size="30" /><i className="fa fa-fw fa-line-eventos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Evento
                        </NavText>
                        <NavItem eventKey="eventos/cadastro">
                            <NavText>
                                Cadastro de Eventos
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="produtos">
                        <NavIcon>
                            <Shopify size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Produtos
                        </NavText>
                        <NavItem eventKey="produtos/cadastro">
                            <NavText>
                                Cadastro de Produtos
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="produtos/precos/cadastro">
                            <NavText>
                                Preços
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="vendas">
                        <NavIcon>
                            <ShoppingCartOutline size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Código Promocional
                        </NavText>
                        <NavItem eventKey="vendas/codigopromocionais/cadastro">
                            <NavText>
                                Comuns
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="vendas/codigopromocionais/associado/cadastro">
                            <NavText>
                                Associados
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="traducoes">
                        <NavIcon>
                            <Translate size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Traduções
                        </NavText>
                        <NavItem eventKey="traducoes/cadastro">
                            <NavText>
                                Paginas
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="formvalidacao">
                        <NavIcon>
                            <Wpforms size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Validação de formulários
                        </NavText>
                        <NavItem eventKey="formvalidacao/cadastro">
                            <NavText>
                                Formulário
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="formvalidacao/perguntas">
                            <NavText>
                                Perguntas e Respostas
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="questionario">
                        <NavIcon>
                            <QuestionAnswer size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Questionários
                        </NavText>
                        <NavItem eventKey="questionario/cadastro">
                            <NavText>
                                Perguntas e Respostas
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="html">
                        <NavIcon>
                            <FileHtml size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Html
                        </NavText>
                        <NavItem eventKey="html/gerenciamento">
                            <NavText>
                                Gerenciamento
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="uploads">
                        <NavIcon>
                            <CloudUpload size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Uploads
                        </NavText>
                        <NavItem eventKey="uploads/pdf">
                            <NavText>
                                PDF
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="termos">
                        <NavIcon>
                            <TextGrammarCheckmark size="30" /><i className="fa fa-fw fa-line-produtos" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Termos
                        </NavText>
                        <NavItem eventKey="termos/gerenciamento">
                            <NavText>
                                Gerenciamento
                            </NavText>
                        </NavItem>
                    </NavItem>
                    <NavItem eventKey="vendas">
                        <NavIcon>
                            <GraphUp size="30" /><i className="fa fa-fw fa-line-vendas" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Relatórios
                        </NavText>
                        <NavItem eventKey="vendas/codigopromocionais/cadastro">
                            <NavText>
                                Todos os Pedidos
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="vendas/codigopromocionais/associado/cadastro">
                            <NavText>
                                Por Produto
                            </NavText>
                        </NavItem>
                        <NavItem eventKey="vendas/codigopromocionais/associado/cadastro">
                            <NavText>
                                Credenciamento
                            </NavText>
                        </NavItem>
                    </NavItem>
                    
                </SideNav.Nav>
            </SideNav>
        )
    }

    const MenuInicial = () => {
        return (
            <SideNav
                style={{ position: "fixed", background: "#e44745" }}
                onSelect={(selected) => {
                    handleMenu(selected);
                }}>
                <SideNav.Toggle />
                <SideNav.Nav defaultSelected="home">
                    <NavItem eventKey="login">
                        <NavIcon>
                            <UserPin size="35" /><i className="fa fa-fw fa-line-vendas" style={{ fontSize: '1.75em' }} />
                        </NavIcon>
                        <NavText>
                            Login
                        </NavText>
                    </NavItem>
                </SideNav.Nav>
            </SideNav>
        )
    }

    return user && user.id ? <MenuAutenticado /> : <MenuInicial />
}

export default Menus;